import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ToothIconProps {
    className?: string
}

export const ToothIcon: FC<ToothIconProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' aria-hidden='true' focusable='false' className={className}>
            <path
                fill='currentColor'
                d='M32 16.4c-3.2-2.6-6.8-3.8-10.4-3.2-6.4 1-9.6 6.6-9 14 .4 4.8 2 8.8 3.2 13.2 1.2 4.4 1.6 9.2 2.8 13.4.8 2.8 2.2 4.4 4 4.4 2.2 0 3.2-2 3.8-4.8l1.6-7.8c.6-2.6 1.8-4 4-4s3.4 1.4 4 4l1.6 7.8c.6 2.8 1.6 4.8 3.8 4.8 1.8 0 3.2-1.6 4-4.4 1.2-4.2 1.6-9 2.8-13.4 1.2-4.4 2.8-8.4 3.2-13.2.6-7.4-2.6-13-9-14-3.6-.6-7.2.6-10.4 3.2z'
            />
        </svg>
    )
}

interface BrandMarkProps {
    name: string
    logo?: string | null
    className?: string
}

export const BrandMark: FC<BrandMarkProps> = ({ name, logo, className }): ReactNode => {
    if (logo) {
        return (
            // eslint-disable-next-line @next/next/no-img-element
            <img
                src={logo}
                alt={`${name} logo`}
                className={cn('size-10 shrink-0 rounded-xl bg-white object-contain p-0.5 ring-1 ring-border', className)}
            />
        )
    }

    return (
        <span
            className={cn(
                'flex size-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-teal-600 to-cyan-700 text-white shadow-sm shadow-teal-900/20',
                className
            )}
        >
            <ToothIcon className='size-[58%]' />
        </span>
    )
}
